module.exports = __webpack_public_path__ + "static/media/window-minimize.506269b6.svg";